module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoadingDataGeneral) ? _c('div', {
    staticClass: "isLoadingDataGeneral"
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.view && _vm.$store.getters.allowedFuncionalities && _vm.doneLoading) ? _c('div', {
    staticClass: "container-fluid center-img-inicial px-0"
  }, [_c('dashboard', {
    attrs: {
      "charts": _vm.dashboardCharts
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb88efa0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb88efa0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/index/index.pug
// module id = 1468
// module chunks = 0